import Topbar from "../../component/Topbar/Topbar";
import Footer from "../../component/Footer/Footer";
import checklist from "../../assets/icon/checklist.svg";
import checklistSize from "../../assets/icon/checklistSize.svg";

import bg from "../../assets/photo/bigDataBackground.webp"

import "../../assets/style/BigData.css"
import { useTranslation } from "react-i18next";

function BigData(params) {
    const { t } = useTranslation();
    const listitem = [
        "Data Collection",
        "Data Storage",
        "E-commerce Integration",
        "Content Management Systems (CMS)",
        "Machine Learning Integration",
        "Security & Compliance"
    ]

    const listwhy = [{
        title: "Expertise",
        text: t("bigdataservice1"),
    },
    {
        title: "Customization",
        text: t("bigdataservice2"),
    },
    {
        title: "Innovation",
        text: t("bigdataservice3"),
    },
    {
        title: "Scalability ",
        text: t("bigdataservice4"),
    },
    {
        title: "Support",
        text: t("bigdataservice5"),
    },
    ]

    return(
        <>
            <Topbar/>
        
            <section className='big'>
                <div className='mainBig'>
                    <img src="/photo/bigDataBackground.webp" className='backgroundMainBig' alt="background" loading='eager' fetchPriority='high'/>
                    <div className='contentMainBig'>
                        <h1 className='white'>Big Data Intelligence</h1>
                    </div>
                </div>
            </section>

            <section className="contentBig">
                <div className="width70">
                    <h1 style={{fontSize: '32px'}}>{t("bigdata1")}</h1>
                    <p className="textNormal">{t("bigdata2")}</p>
                
                    <p className="titleNormal">Big Data Intelligence Solutions</p>
                    <p className="textNormal" >{t("bigdata3")}</p>

                    {listitem.map((item, index) => (
                    <div key={index} className="itemBig" style={{marginBottom: '8px'}}> 
                        <div className="dflex" alt="check">
                            <img src={checklist} alt="what?"/>
                        </div>
                        <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                    </div>
                    ))}

                    <p className="titleNormal">{t("bigdata4")}</p>

                    {listwhy.map((item, index) => (
                    <div key={index} className="itemWhy">
                        <div className="dflex">
                            <img src={checklistSize} alt="check"/>
                        </div>
                        <div>
                        <h2 className="titleItemWhyBig">{item.title}</h2>
                        <h2 className="textItemWhyBig">{item.text}</h2>
                        </div>
                    </div>
                    ))}
                </div>

                <div className="cardSoftware">
                    <p className="titleHigh">{t("sidecardtitle")}</p>
                    <p className="textNormal mb64">{t("sidecardtext")}</p>
                    <div>
                        <button className="buttonBlack" onClick={() => {window.open('https://wa.me/6281703090603', '_blank')}}>{t("hpc1colaboration")}</button>
                    </div>
                </div>
            </section>

            <Footer/>
        </>
    )
}

export default BigData